export default {
  namespaced: true,

  state: () => ({
    isLoading: false,
  }),

  getters: {},

  mutations: {
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
  },

  actions: {
    // get
    async sendNotif({ commit }, { data = null, users = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = 'v1/admin/fcm-token/send'
        const all = data.all_user === '1'

        const payload = {
          ...data,
          all_user: all,
        }

        if (!all) payload.users = users
        const response = await this._vm.$http.post(url, payload)

        commit('SET_LOADING', false)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengirim Notifikasi!',
        }, { root: true })

        return response
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Mengirim Notifikasi!',
        }, { root: true })
        return error
      }
    },
  },
}
